import { render } from "./TasksOrderListView.vue?vue&type=template&id=3f863f9a"
import script from "./TasksOrderListView.vue?vue&type=script&lang=js"
export * from "./TasksOrderListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__